<script>
  import { onMount, createEventDispatcher } from "svelte";
  import request from 'superagent';
  
  const dispatch = createEventDispatcher();
  const defaultItem = { "title": "", "href": "", "text": "" };
  
  export let query = "";
  
  let page = 1;
  let items = [];
  
  onMount(getItems);
  
  function getItems() {
    if (query == "" || page < 1)
      return;
  
    request.post(`/p/search.json`).send({q: query, page})
      .then(resp => {
        let body = resp.body;
        if (body)
          items = body;
      });
  }
</script>
<div class='mx-auto mb-3'>
{#if items.length}
{#each items as {href, title, text}, i}
<div class='row my-1'>
<div class='col-12'>
<div class='media mt-3'>
<div class='media-body'>
<a class='d-block' href='{href}'>{title}</a>
<small>
<a class='d-block badge badge-light text-left' href='{href}'>{href}</a>
{text}
</small>
</div>
</div>
</div>
</div>
{/each}
{/if}
</div>
